import logo from "./logo.png";
export default function Navbar() {
	return (
		<header>
			<nav id="navbar">
				<a href="#about">
					<img src={logo} id="logoNav" alt="logo" width={50} height={50} />
				</a>
				<ul id="nav-list">
					{/*<li><img src={logo} className="App-logo" alt="logo" width={50} height={50}/></li>*/}
					<li>
						<a href="#about">About Me</a>
					</li>
					<li>
						<a href="#projects">My Work</a>
					</li>
					<li>
						<a href="#contact-me">Get in Touch</a>
					</li>
				</ul>
			</nav>
		</header>
	);
}
